import amplitude from 'amplitude-js';
import config from '@/config';

const amplitudeKey =
  window.location.hostname === config.siteHost
    ? config.amplitudeKey.prod
    : config.amplitudeKey.dev;

const amplitudeInstance = amplitude.getInstance();

amplitudeInstance.init(amplitudeKey);

export { amplitudeInstance };
